"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryInsights = void 0;
const react_query_1 = require("react-query");
function queryInsights(query, { variables, context, }, { socket, rateLimitQueue, signal, backendUrl, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const compiledQuery = query(variables);
        if (backendUrl) {
            return queryInsightsExperimental({
                compiledQuery,
                locationId: context.locationId,
                sessionId: socket.sessionId,
                host: new URL(socket.url).host,
                backendUrl,
            });
        }
        const release = yield rateLimitQueue.getHandle();
        const timeBefore = Date.now();
        try {
            if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                throw new react_query_1.CancelledError();
            }
            const cirrusRequest = createCirrusRequest(compiledQuery, context);
            const response = yield Promise.race([
                socket.request(cirrusRequest),
                new Promise((_, reject) => setTimeout(reject, 30000)),
            ]);
            const parsed = parseResult(response);
            if (parsed.error) {
                throw new Error(parsed.error);
            }
            return parsed;
        }
        catch (error) {
            throw error;
        }
        finally {
            if (process.env.NODE_ENV === 'development') {
                const timeAfter = Date.now();
                const difference = timeAfter - timeBefore;
                if (difference > 200) {
                    console.warn(`Slow execution of query ${compiledQuery.id}. Took`, timeAfter - timeBefore, 'ms. Info:', {
                        compiledQuery,
                    });
                }
            }
            release();
        }
    });
}
exports.queryInsights = queryInsights;
function queryInsightsExperimental({ locationId, compiledQuery, sessionId, host, backendUrl, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const varsBase64 = btoa(JSON.stringify(compiledQuery.params));
        if (varsBase64.length < 175) {
            const res = yield fetch(`${backendUrl}/v1/locations/${locationId}/analytics/${compiledQuery.id}?host=${host}&variables=${varsBase64}`, { headers: { Authorization: `Bearer ${sessionId}` } });
            if (!res.ok) {
                try {
                    throw new Error('Failed to fetch query:' + (yield res.text()));
                }
                catch (_a) {
                    throw new Error('Failed to fetch query');
                }
            }
            const json = yield res.json();
            const data = json;
            return data;
        }
        else {
            const res = yield fetch(`${backendUrl}/v1/locations/${locationId}/analytics/${compiledQuery.id}?host=${host}`, {
                headers: { Authorization: `Bearer ${sessionId}`, 'Content-Type': 'application/json' },
                method: 'POST',
                body: JSON.stringify({ variables: compiledQuery.params }),
            });
            if (!res.ok) {
                try {
                    throw new Error('Failed to fetch query:' + (yield res.text()));
                }
                catch (_b) {
                    throw new Error('Failed to fetch query');
                }
            }
            const json = yield res.json();
            const data = json;
            return data;
        }
    });
}
function createCirrusRequest(query, { mode, locationId }) {
    const blobData = createBlobData({ compiledQuery: query, mode, locationId });
    return {
        messageType: 'CirrusBlobRequest',
        locationAddress: {
            resourceType: 'LocationAddress',
            locationId,
        },
        list: [
            {
                resourceType: 'BlobDTO',
                blobType: 'tsdb',
                blobData,
            },
        ],
    };
}
function parseResult(response) {
    var _a, _b, _c;
    return JSON.parse((_c = (_b = (_a = response.list) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.blobData) !== null && _c !== void 0 ? _c : '');
}
function createBlobData({ compiledQuery, locationId, mode, }) {
    if (mode === 'DEVELOPMENT') {
        return JSON.stringify({
            query: compiledQuery.prepared,
            params: compiledQuery.params,
            types: compiledQuery.types,
            lid: locationId,
        });
    }
    else {
        return JSON.stringify({
            query: 'id ' + compiledQuery.id,
            lid: locationId,
            params: compiledQuery.params,
        });
    }
}
//# sourceMappingURL=queryInsights.js.map